import dayjs from '@/lib/dayjs'
import { PHONE_CLICK_REPORT_SORT } from '@/lib/services/reports/reports.schema'
import type { PhoneClickReportRow } from '@/lib/services/reports/reports.types'
import type { ColumnDef } from '@tanstack/react-table'

export const phoneClickColumns: ColumnDef<PhoneClickReportRow>[] = [
  {
    accessorKey: 'date',
    header: 'Date',
    cell: ({ row }) => (
      <time dateTime={row.original.date}>{dayjs(row.original.date).format('MMM D, YYYY')}</time>
    ),
    meta: {
      label: 'Date',
      kind: 'date',
      sortable: { asc: PHONE_CLICK_REPORT_SORT.DATE_ASC, desc: PHONE_CLICK_REPORT_SORT.DATE_DESC },
      headClassName: 'whitespace-nowrap px-4',
      cellClassName: 'whitespace-nowrap px-4 py-3 tabular-nums',
    },
  },
  {
    accessorKey: 'phone_display',
    header: 'Phone Number',
    cell: ({ row }) => <span translate="no">{row.original.phone_display}</span>,
    meta: {
      label: 'Phone Number',
      kind: 'primary',
      sortable: {
        asc: PHONE_CLICK_REPORT_SORT.PHONE_ASC,
        desc: PHONE_CLICK_REPORT_SORT.PHONE_DESC,
      },
      headClassName: 'whitespace-nowrap px-4',
      cellClassName: 'whitespace-nowrap px-4 py-3 font-medium',
    },
  },
  {
    accessorKey: 'clicks_count',
    header: 'Clicks/Taps',
    cell: ({ row }) => Number(row.original.clicks_count).toLocaleString(),
    meta: {
      label: 'Clicks/Taps',
      kind: 'number',
      sortable: {
        asc: PHONE_CLICK_REPORT_SORT.CLICKS_ASC,
        desc: PHONE_CLICK_REPORT_SORT.CLICKS_DESC,
      },
      align: 'end',
      headClassName: 'whitespace-nowrap px-4',
      cellClassName: 'whitespace-nowrap px-4 py-3 font-medium tabular-nums',
    },
  },
]
